import React from 'react'

export default function ProgressSteps({ currentStep = 1, steps = [] }) {
  return (
    <div className="flex justify-center items-center max-w-[512px] mb-4">
      <div className="flex items-center">
        {steps.map((step, index) => {
          const stepNumber = index + 1
          const isCompleted = stepNumber < currentStep
          const isCurrent = stepNumber === currentStep
          const isLast = index === steps.length - 1

          return (
            <React.Fragment key={step.key}>
              <div className="flex items-center gap-0.5 sm:gap-2 flex-shrink-0">
                {/* Circle */}
                {isCompleted ? (
                  // Completed: Filled purple circle with white tick
                  <div className="flex items-center justify-center w-4 h-4 sm:w-5 sm:h-5 rounded-full bg-[#5C33FF]">
                    <svg className="w-3 h-3 text-white" viewBox="0 0 20 20" fill="currentColor">
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                ) : (
                  // Current or Future: Outlined circle
                  <div
                    className={[
                      'flex items-center justify-center w-4 h-4 sm:w-5 sm:h-5 rounded-full border-2',
                      isCurrent ? 'border-[#5C33FF]' : 'border-gray-300',
                    ].join(' ')}
                  >
                    {/* Very small inner circle for current step */}
                    {isCurrent && (
                      <div className="sm:w-1.5 sm:h-1.5 w-1 h-1 rounded-full bg-[#5C33FF]" />
                    )}
                  </div>
                )}
                <span
                  className={[
                    'text-sm font-medium whitespace-nowrap',
                    isCompleted ? 'text-gray-900' : isCurrent ? 'text-[#5C33FF]' : 'text-gray-500',
                  ].join(' ')}
                >
                  {step.title}
                </span>
              </div>

              {/* Connector line */}
              {!isLast && (
                <div className="mx-0.5 sm:mx-3">
                  <div
                    className={[
                      'h-0.5 w-1 sm:w-10',
                      isCompleted ? 'bg-[#5C33FF]' : 'bg-gray-200',
                    ].join(' ')}
                  />
                </div>
              )}
            </React.Fragment>
          )
        })}
      </div>
    </div>
  )
}
